export default __webpack_public_path__ + "images/0xff20817765cb7f73d4bde2e66e067e58d11095c2.png";